import { extractEventContext } from './contexts';
import type { AnalyticsEvent, RawAnalyticsEventContext } from './types';

/**
 * Transform an event into a raw format for Amplitude/Segment.
 */
export function prepareRawEvent(event: AnalyticsEvent): {
    type: string;
    properties: object;
    context: RawAnalyticsEventContext;
} {
    const { properties: payload, context } = extractEventContext(event);
    const { type, ...properties } = payload;

    switch (event.type) {
        // Screen/Page views are converted to a unique name depending on the screen/site e.g.
        case 'screen_view':
            return {
                type: `view_${event.screen}`,
                context,
                properties: {
                    ...properties,
                    // Extract the section from the screen (everything before the first underscore)
                    // and add it as a new field.
                    screenSection: event.screen.split('_')[0],
                },
            };

        case 'click': {
            const { action: _action, ...clickProperties } = properties as {
                action: unknown;
                [key: string]: unknown;
            };

            return {
                type: `click_${event.action}`,
                properties: clickProperties,
                context,
            };
        }

        default:
            return {
                type,
                properties,
                context,
            };
    }
}
